<script setup>
import { inject, computed } from 'vue'
import { useVModel } from '#/general/useVModel'
import AppField from '#/general/AppField'
const { components, application, screen, global } = inject('Shared')
const props = defineProps([
  'value',
  'placeholder',
  'name',
  'errors'
])
const emit = defineEmits(['update:value'])
const value = useVModel(props, 'value')

function input (event) {
  emit('update:value', event.target.value)
}

const errorMessage = computed(() => {
  if (props.errors) {
    const keys = Object.keys(props.errors)
    if (keys && keys.length > 0) {
      return props.errors[keys[0]]
    }
  }
  return null
})
</script>

<template lang="pug">
app-field(:error-message="errorMessage" :hide-separator="true")
  .us--contact-input-container
    input.us--contact-input(
      :placeholder="placeholder"
      v-model="value"
      :name="name"
    )
</template>

<style lang="sass">
.us--contact-input-container
  border-bottom: 1px solid #626C85
  @media screen and (min-width: 1024px)
    padding-left: 15px
    padding-bottom: 10px
  @media screen and (max-width: 1024px)
    padding-left: 10px
    padding-bottom: 7px
  .us--contact-input
    border: none
    font-weight: 500
    line-height: 130%
    color: #626C85
    width: 100%
    @media screen and (min-width: 1024px)
      font-size: 16px
    @media screen and (max-width: 1024px)
      font-size: 16px

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus
  -webkit-transition-delay: 9999s !important
  transition-delay: 9999s !important
  color: #626C85 !important
  -webkit-text-fill-color: #626C85 !important
</style>
